import React from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { quickQuotes } from '../data/content';
export function QuickProof() {
  return <section className="w-full bg-canvas py-16 md:py-20" data-id="element-121" data-mp="1f1e2gr8qak3">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-122" data-mp="3ix45hmkr5hf2">
        <h2 className="flex items-center justify-center gap-3 text-center font-display text-2xl font-extrabold tracking-tight text-night md:text-3xl" data-id="element-123" data-mp="3nvfejv383nw8">
          <CheckCircle2Icon className="h-7 w-7 shrink-0 text-grass-500" aria-hidden="true" data-id="element-124" data-mp="39uutstdqzi03" />
          Lo que dicen los profesionales que ya lo usan
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-125" data-mp="2zxzzynsf65s5">
          {quickQuotes.map(quote => <li key={quote.author} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-soft ring-1 ring-gray-200" data-id="element-126" data-mp="34vrt1l4svxxx">
              <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-127" data-mp="1356gzz51p9og">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-128" data-mp="z7jaqbnp2bbu" data-mpi={index} />)}
              </span>
              <p className="mt-4 text-[1.0625rem] leading-snug text-ink" data-id="element-129" data-mp="180cvuppto4xm">“{quote.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-130" data-mp="140cf2yf93hne">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-night font-display text-xs font-bold text-amber-400" data-id="element-131" data-mp="gazxba5uy19h">
                  {quote.initials}
                </span>
                <span className="min-w-0" data-id="element-132" data-mp="pbfww8jhco92">
                  <span className="block truncate font-display text-sm font-extrabold text-night" data-id="element-133" data-mp="kbjtaaep2yu1">
                    {quote.author}
                  </span>
                  <span className="block truncate text-xs text-gray-500" data-id="element-134" data-mp="20o8mbcost0ly">
                    {quote.role} | {quote.city}
                  </span>
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}